import dayjs from 'dayjs';
import {
  useCreateStripePortalSession,
  useCurrentUser,
  useGetOrgUsersCount,
} from 'src/hooks';
import type { SubscriptionTier } from 'src/types';

type Props = {
  subTier: SubscriptionTier;
};

export const ManageSubDetails = ({ subTier }: Props) => {
  const { user } = useCurrentUser();

  const { data: usersCount } = useGetOrgUsersCount();

  const { mutate: createStripePortalSession, isPending } =
    useCreateStripePortalSession();

  if (subTier === 'free') {
    return null;
  }

  return (
    <>
      {subTier === 'organization' ? (
        <div className='flex w-full flex-col flex-wrap items-start justify-center gap-6 md:flex-row md:items-center md:justify-start md:gap-8 lg:gap-10'>
          <div className='flex flex-col items-start justify-center gap-2'>
            <span className='text-100 text-primary-dark'>No. of Users</span>
            <span className='heading-100 text-primary-dark'>
              {usersCount?.usersCount}
            </span>
          </div>
          <div className='flex flex-col items-start justify-center gap-2'>
            <span className='text-100 text-primary-dark'>Domain</span>
            <span className='heading-100 text-primary-dark'>
              {user?.email?.split('@')[1]}
            </span>
          </div>
        </div>
      ) : null}

      {subTier === 'personal' ||
      (subTier === 'organization' && user?.subscription?.role === 'admin') ? (
        <div
          className={`flex w-full max-w-[700px] flex-row flex-wrap gap-4 md:gap-5 lg:gap-6 ${user?.subscription.status === 'active' || user?.subscription.status === 'payment_failed' ? 'items-center justify-start' : 'items-center justify-start'}`}
        >
          <div className='flex flex-col items-center justify-center gap-2'>
            <span className='text-100 text-primary-dark'>
              {!user?.subscription.customerId
                ? 'Subscription Gifted'
                : user?.subscription.status === 'active'
                  ? 'Billing Date'
                  : 'End Date'}
            </span>
            <span className='heading-100 text-primary-dark'>
              {user?.subscription.endDate
                ? dayjs(user.subscription.endDate)
                    .subtract(1, 'day')
                    .format('MMM D, YYYY')
                : 'Error'}
            </span>
          </div>
          {/* If user doesn't have a customer Id, we don't show anything */}
          {!user?.subscription.customerId ? null : (
            <>
              {/* If status is active or payment_failed, we show 'Manage Stripe Billing Info', otherwise this is hidden */}
              {user?.subscription.status === 'active' ||
              user?.subscription.status === 'payment_failed' ? (
                <button
                  onClick={() => createStripePortalSession()}
                  disabled={isPending}
                  className='button-secondary h-12'
                >
                  Manage Stripe Billing Info
                </button>
              ) : (
                ''
              )}
              <button
                onClick={() => createStripePortalSession()}
                disabled={isPending}
                className='button-secondary h-12'
              >
                {user?.subscription.status === 'active' ||
                user?.subscription.status === 'payment_failed'
                  ? 'Cancel Subscription'
                  : 'Continue Subscription'}
              </button>
            </>
          )}
        </div>
      ) : null}
    </>
  );
};
